import Button from "@mui/material/Button";
import { Plus } from "@/assets/svgs/Plus";

export default function EntityCreateButton(props) {
    const { setPopupOpen } = props;
    const handleEntityCreateButton = () => {
        setPopupOpen(true);
    };
    return (
        <Button
            endIcon={<Plus />}
            onClick={handleEntityCreateButton}
            color="primary"
        >
            Add
        </Button>
    );
}
